<template>
    <div class="selector-box">
        <div class="main-type-box">
            <TypeSelectOption
                v-for="(v, index) in mainTypeList"
                :key="v.typeCode"
                :obj="v"
                :selected="currType === v.typeCode || parentType === v.typeCode"
                @click="clickMainType(v)"
            />
        </div>

        <div class="sub-type-box">
            <TypeSelectOption
                v-for="(v, index) in subTypeList"
                :key="v.typeCode"
                :obj="v"
                :selected="currType === v.typeCode"
                @click="clickSubType(v)"
            />
        </div>
    </div>
</template>

<script setup>

import TypeSelectOption from "@/components/Shopopee3D/ui/typeSelectOption.vue";
import {watch} from "vue";

const props = defineProps(["mainTypeList", "subTypeList", "currType", "parentType"])
const emits = defineEmits(["selectOption"])

function clickMainType(obj){
    if (true === obj.disabled){
        return
    }else{
        emits("selectOption", obj)
    }
}

function clickSubType(obj){
    emits("selectOption", obj)
}

</script>

<style scoped>

.selector-box {
    box-sizing: border-box;
    padding: 10px;
    text-align: left;
}

.main-type-box {
    border-bottom: 1px #CDD0D6 solid;
    overflow-x: auto;
    overflow-y: hidden;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
}
@media screen and (min-width: 768px) {
    .sub-type-box {

    }
}

@media screen and (max-width: 768px) {
    .sub-type-box {

    }
}

</style>